(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  const wrapper = document.querySelector(".mobile-scroll-wrapper");
  if (!wrapper) return;

  const scrollContainer = wrapper.querySelector(".mobile-scroll");
  const leftBtn = wrapper.querySelector(".scroll-left");
  const rightBtn = wrapper.querySelector(".scroll-right");

  if (!scrollContainer) return;

  const scrollAmount = scrollContainer.offsetWidth;

  rightBtn.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
  });

  leftBtn.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  });
});
  } catch(e) { console.error(e); }
})();

})();
